"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = Snackbar;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _react2 = require("../..");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _q = require("q");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    color: ", ";\n    font-weight: 600;\n    font-size: ", "rem;\n    cursor: pointer;\n    margin-left: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    min-width: ", "px;\n    min-height: ", "px;\n    position: absolute;\n    align-items: center;\n    justify-content: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-size: ", "rem;\n    font-family: ", ";\n    padding: 0 ", "px;\n    opacity: ", ";\n    visibility: ", ";\n    transition-delay: 2s, 0s;\n    transition-property: visibility, opacity; \n    transition-duration: 0s, 1s;\n    z-index: ", ";\n    cursor: default;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SnackbarWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.spacingObj.minWidth;
}, function (props) {
  return props.spacingObj.minHeight;
}, function (props) {
  return props.action ? 'space-between' : 'center';
}, function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.colorObj.textColor;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 'visible' : 'hidden';
}, function (props) {
  return props.spacingObj.zIndex;
});

var Action = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.color;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.spacingObj.margin * 2;
});
/**
 * Snackbars provide brief messages about processes with an optional action.
 * By default, Snackbars timeout after five seconds.
 * @example import { Snackbar } from '@desktop/react'; 
 */


function Snackbar(props) {
  var inherit = 'snackbar';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit];

  var _useState = (0, _react.useState)(props.visible),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    if (visible && !props.persist) {
      setTimeout(function () {
        setVisible(false);
      }, props.timeout);
    }
  }, [visible]);
  (0, _react.useEffect)(function () {
    setVisible(props.visible);
  }, [props.visible]);
  var actionColor = props.actionColor ? props.actionColor : colors.textColor;
  return /*#__PURE__*/_react["default"].createElement(SnackbarWrapper, {
    fontFamilyObj: context.getFont(),
    spacingObj: spacing,
    colorObj: colors,
    action: props.action,
    style: props.style,
    visible: visible
  }, props.children, props.action && /*#__PURE__*/_react["default"].createElement(Action, {
    onClick: props.action.onClick,
    color: actionColor,
    spacingObj: spacing
  }, props.action.name));
}

Snackbar.propTypes = {
  /**The text displayed in the snackbar. */
  children: _propTypes["default"].string,

  /**An object with a name (string) and action (function) property. */
  action: _propTypes["default"].object,

  /**The color of the action text. */
  actionColor: _propTypes["default"].string,

  /**Extends the base styling of the snackbar. */
  style: _propTypes["default"].object,

  /**Toggles the visibility of the snackbar. */
  visible: _propTypes["default"].bool,

  /**The time in ms that the snackbar stays visible. */
  timeout: _propTypes["default"].number,

  /**Causes the snackbar to stay visible */
  persist: _propTypes["default"].bool
};
Snackbar.defaultProps = {
  action: null,
  actionColor: null,
  style: {},
  visible: true,
  timeout: 5000,
  persist: false
};